import { useBrandingConfig } from '@app/data/Branding';
import { mapBrandingConfig } from './mapper';
import { useMemo } from 'react';

export function useDashboardBranding() {
	const { data: brandingConfig } = useBrandingConfig();

	const mappedConfig = useMemo(
		() => mapBrandingConfig(brandingConfig),
		[brandingConfig]
	);

	return mappedConfig;
}
